import type { PmsProduct } from "~/types"
import type { MemberProductCollection } from "~/types/MemberProductCollection"

export const useWishlistStore = defineStore('wishlist', () => {
    const wishlist = ref<MemberProductCollection[]>([])
    const errorLoading = ref()
    const productCollection = productCollectionRepository()

    function reset() {
        wishlist.value = []
        errorLoading.value = undefined
    }

    async function fetchWishlist() {
        try {
            if (wishlist.value.length > 0) return
            const data = await productCollection.fetchProductCollectionList(1, 50)
            if (data !== null && data.code === 200) {
                wishlist.value.push(...(data.data.list || []));
                errorLoading.value = undefined
            } else {
                errorLoading.value = 'Error during fetching wishlist ' + data.message
                console.error('Failed to fetch wishlist:', data.code);
            }
        } catch (reason) {
            errorLoading.value = 'Error during registration: ' + reason
            console.error('Error during registration:', reason);
        }
    }

    async function addToWishlist(pmsProduct: PmsProduct) {
        try {
            const collection = convertProductToWishlist(pmsProduct)
            const data = await productCollection.createProductCollection(collection)
            if (data.code === 200) {
                wishlist.value.push(collection)
                return 'ok'
            } else {
                return 'Error during adding wishlist ' + data.code
            }
        } catch (reason) {
            console.error('Error during registration:', reason);
            return 'Error during registration: ' + reason
        }
    }

    async function deleteWishlist(id: number) {
        try {
            if (id < 1) return 'id can not be less than 1'
            const data = await productCollection.deleteProductCollection(id)
            if (data.code === 200) {
                return 'ok'
            } else {
                return 'Error during deleting wishlist ' + status
            }
        } catch (reason) {
            console.error('Error during registration:', reason);
            return 'Error during registration: ' + reason
        }
    }

    function removeItemByProductId(productId: number) {
        const index = wishlist.value.findIndex(item => item.productId === productId);
        if (index !== -1) {
            wishlist.value.splice(index, 1); // Remove 1 item at the found index
        }
    }

    const isFavorite = computed(() => {

        return (productId: number) => {
            const isFav = wishlist.value.some(item => item.productId === productId)
            // console.log('----------- ' + isFav + ' --------- ' + productId + '---' + wishlist.value.length)
            return isFav
        };
    })

    function convertProductToWishlist(pmsProduct: PmsProduct) {
        const userStore = useUserStore()
        return <MemberProductCollection>{
            productId: pmsProduct.id,
            productName: pmsProduct.name,
            productPic: pmsProduct.pic,
            productPrice: pmsProduct.price,
            productSubTitle: pmsProduct.subTitle,
            ratings: pmsProduct.avgRating,
            ratingCounts: pmsProduct.ratingCount,
            createTime: new Date(),
            memberId: userStore.user?.memberLevelId,
            memberNickname: userStore.user?.nickname,
            memberIcon: userStore.user?.icon
        }
    }
    return {
        wishlist,
        fetchWishlist,
        deleteWishlist,
        removeItemByProductId,
        addToWishlist,
        reset,
        isFavorite
    }
})